export const APP_STATE = {
	INITIALIZING: 'initializing',
	NORMAL:       'normal',
};

export const LATEST_TAGS_NUMBER = 19;
export const MAX_INTERVAL = 2_147_483_647;

export const WS_RETRY_INTERVAL = 30_000;

export const APP_TYPE_VIEW_MODE = 'view-mode';
export const APP_TYPE_TAGGING_TOOL = 'tagging-tool';
export const APP_TYPE_FULL_PAGE_MODE = 'full-page-mode';
export const APP_TYPE_COUCH_MODE = 'couch-mode';

export const APP_TYPE = {
	VIEW_MODE:      'view-mode',
	TAGGING_TOOL:   'tagging-tool',
	FULL_PAGE_MODE: 'full-page-mode',
	MOMENTS:        'moments',
};

export const APP_MODE = {
	UNMANAGED: null,
	EMBEDDED:  'embedded',
};
